<template>
	<div v-show="show">
		<vx-card id="loading-deposit" class="vs-con-loading__container">
			<vs-row v-if="depotUpdatePermission">
				<div class="vx-col w-full">
					<DepotForm v-if="item.hasOwnProperty('id')" :data="item" :isEditActive="true" :key="key" />
				</div>
			</vs-row>

			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>
<script>
import Api from "@/helpers/api.js";
import DepotForm from "@/components/depot/DepotForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Team",
	data() {
		return {
			item: {},
			key: 1,
			show: false,
		};
	},
	props: {
		data: Object,
	},
	components: {
		DepotForm,
		NotPermission,
	},
	computed: {
		depotUpdatePermission() {
			return this.$store.getters.checkPermission("DEPOSITS_U");
		},
	},
	methods: {
		getDepotData(id) {
			return new Promise((resolve, reject) => {
				Api.get("/depot/" + id)
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			});
		},
		consultDepot() {
			this.$vs.loading();
			this.getDepotData(this.$route.params.id || this.data.id)
				.then((result) => {
					this.item = result.data;
					if (!this.depotUpdatePermission) {
						this.$vs.loading.close();
					}
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Deposits.Messages.DepositNotFound"),
					});
					this.$router.push("/dashboard/deposits/list");
				});
		},
	},
	mounted() {
		this.show = true;
	},
	created() {
		this.consultDepot();
	},
};
</script>
